// extracted by mini-css-extract-plugin
export var brand = "_2x-9";
export var compact = "_2x-6";
export var extraSmall = "_2x-7";
export var icon = "_2x-0";
export var large = "_2x-4";
export var light = "_2x-1";
export var medium = "_2x-5";
export var outline = "_2x-b";
export var primaryDark = "_2x-a";
export var primaryLight = "_2x-8";
export var primaryModern = "_2x-c";
export var success = "_2x-2";
export var successSolid = "_2x-3";